import type { AiPreference } from "../shared/connect-ai";

export interface SetupAnswers {
  agentName: string;
  dayOneFocus: string | null;
  aiPreference: AiPreference;
  aiMode: AiPreference;
  connectedAccounts: string[];
  budgetPreference: string | null;
  limitedModeConfirmed: boolean;
}

export interface SetupTourProgress {
  currentStep: string | null;
  completedSteps: string[];
  skippedSteps: string[];
}

export interface SetupProfile {
  completed: boolean;
  completedAt: string | null;
  phase: "setup" | "tour" | "complete";
  currentStep: string;
  agentName: string;
  answers: SetupAnswers;
  tourProgress: SetupTourProgress;
  startedAt: string;
}

export async function fetchSetupProfile(): Promise<SetupProfile> {
  const response = await fetch("/api/onboarding");
  if (!response.ok) {
    throw new Error("Failed to load setup state");
  }
  return response.json();
}

export async function saveSetupProfile(body: Record<string, unknown>): Promise<void> {
  const response = await fetch("/api/onboarding", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    throw new Error("Failed to save setup state");
  }
}
